import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

const CategoryChip = styled(NavLink)`
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.gray600};
  border-radius: 2rem;
  color: ${props => props.theme.colors.black};
  font-size: ${props => props.theme.fontSizes[0]};
  padding: ${props => props.theme.space[1]} ${props => props.theme.space[2]};
  position: relative;
  margin: ${props => props.theme.space[1]};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.colors.blue700};
  }

  &:focus {
    outline: none;
  }

  &:after {
    content: '';
    position: absolute;
    inset: -3px; // 2px gap + 1px to clear border
    border-radius: 2rem;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
    opacity: 0;
  }

  &:focus:after {
    opacity: 1;
  }

  &.active {
    border-color: transparent;
    background: ${props => props.theme.colors.blue500};
    color: white;
  }

  &.active:hover {
    color: white;
  }
`

CategoryChip.displayName = 'CategoryChip'

export default CategoryChip
